/* unplugin-vue-components disabled */import script from "./DemoPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DemoPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__